import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const noAuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    const user = authService.currentUser();
    const isActive = user?.active !== false && user?.status !== 'INACTIVE';
    if (isActive) {
      router.navigate(['/admin/inicio']);
      return false;
    }
  }

  return true;
};
